import ls from 'local-storage'

export const storeValue = (key: string, value: any) => {
  try {
    ls(key, value)
  } catch (err) {}
}

export const getValue = <T = any>(key: string): null | T => {
  try {
    return ls.get(key)
  } catch (err) {}
}
